var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "w-full" },
    [
      _vm._t("header-content"),
      _vm._v(" "),
      _vm._t("body-content"),
      _vm._v(" "),
      _vm.showButton
        ? _c("ButtonSection", {
            attrs: {
              inputValid: _vm.inputValid,
              buttonText: _vm.step.buttonText,
              backButtonText: _vm.step.backButtonText,
              exitButtonText: _vm.step.exitButtonText,
              buttonStyling: _vm.buttonStyling,
            },
            on: {
              progress: function ($event) {
                return _vm.$emit("progress")
              },
              back: function ($event) {
                return _vm.$emit("back")
              },
              "hide-modal": function ($event) {
                return _vm.$emit("hide-modal")
              },
            },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }